<div *ngIf="(paymentRequestStatusList$ | async) as paymentRequestStatusList; else loadingTemplate">
  <div class="form-group" *ngIf="paymentRequestStatusList.length > 0; else noDataTemplate">
    <label [hidden]="hideLabel" for="SelectedPaymentRequestStatus">Payment Request Status</label>
    <ng-select required [items]="paymentRequestStatusList" bindLabel="Description" [multiple]="false"
               [hideSelected]="true"
               [loading]="paymentRequestStatusListLoading" [typeahead]="paymentRequestStatusListInput$"
               [(ngModel)]="selectedPaymentRequestStatus" name="SelectedPaymentRequestStatus"
               placeholder="{{selectStatusText}}" (change)=selectedPaymentRequestStatusChanged($event)>
    </ng-select>
  </div>
  <ng-template #noDataTemplate>
    There are no payment request statuses avaliable yet.
  </ng-template>
</div>
<ng-template #loadingTemplate>
  There are no payment request statuses avaliable yet.
</ng-template>
